define('common/ko/extension/cash',['underscore', 'accounting', 'knockout'], function (_, accounting, ko) {

    var iso4217CurrencyCodeToSymbol = {
        'EUR': '\u20AC',
        'GBP': '\u00A3'
    };

    ko.subscribable.fn.settings = ko.subscribable.fn.settings || ko.observable();

    ko.extenders.cash = function (target, conf) {

        conf = _.extend({
            precision: 2,
            decimal: '.',
            thousand: ',',
            format: {
                pos: '%s%v',
                neg: '%s-%v',
                zero: '%s0'
            }
        }, conf);

        function isCash(v) {
            return !_.isUndefined(v) && ko.isObservable(v.amount) && ko.isObservable(v.iso4217CurrencyCode);
        }

        function format(normalized) {
            var cash = target();
            var amount;
            var c = _.extend(conf);

            if (isCash(cash)) {
                amount = cash.amount();
                c.symbol = cash.currencySymbol();
            } else {
                amount = cash;
                c.symbol = iso4217CurrencyCodeToSymbol[target.settings().selectedCurrencyCode()];
            }

            if (amount === '\u221e') {
                return c.symbol + '\u221e';
            } else {
                return accounting.formatMoney(normalized ? Math.abs(amount) : amount, c);
            }
        }

        target.formattedCash = ko.pureComputed(function () {
            return format(false);
        });

        target.normalizedFormattedCash = ko.pureComputed(function () {
            return format(true);
        });

        return target;
    };
});

